export const SUCCESS_ANNOUNCEMENT = "SUCCESS_ANNOUNCEMENT";
export const LOADING_ANNOUNCEMENT = "LOADING_ANNOUNCEMENT";
